var $ = window.jQuery = require('jquery');
import nameList from '../../services/name.json'
import game_header from '../../components/game-header/index.vue';
export default {
  name: 'wall-street-giants',
  components: {
    'game-header': game_header
  },
  props: [],
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {
    var id1;
    var count = 1; //question count
    var myArray = []; // to randomise the order of questions
    $('.routeloader').show();

    function shuffle(a) {
      var j, x, i;
      for (i = a.length; i; i -= 1) {
        j = Math.floor(Math.random() * i);
        x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
      }
    }

    function populate(a) {
      var length = 10;
      for (var i = 0; i < length; i++) {
        myArray[i] = i + 1;
      }
    }
    $(document).ready(function() {
      populate(myArray);
      shuffle(myArray);
    });

    function allowDrop(ev) {
      ev.preventDefault();
    }

    function drag(ev) {
      id1 = ev.target.id;
    }

    function drop(ev) {
      ev.preventDefault();
      var data1 = $('#' + id1).html();
      $('#' + id1).html($('#' + ev.target.id).html());
      $('#' + ev.target.id).html(data1);
    }
    var timer1;

    function result() {
      var i;
      var id;
      var fname = '';
      var lname = '';
      var level = myArray[(count - 1)];
      console.log('result' + level);
      for (i = 1; i <= 12; i++) {
        id = "#fbox" + i;
        if (($(id).text() >= 'A') && ($(id).text() <= 'Z')) {
          fname += $(id).text();
        }

        id = "#lbox" + i;
        if (($(id).text() >= 'A') && ($(id).text() <= 'Z')) {
          lname += $(id).text();
        }

      }
      let data = 0;
      let correctfname = nameList[level].fname;
      let correctlname = nameList[level].lname;
      if (fname == correctfname && lname == correctlname) {
        data = 1;
      } else {
        data = 0;
      }
      var i;
      var point;
      for (i = 1; i <= 12; i++) {
        id = "#firstName" + i;
        $(id).html('&nbsp;');

        id = "#lastName" + i;
        $(id).html('&nbsp;');

      }
      if (data == 0) {
        point = (count - 1) * 20;
        $('#resultTitle').html('OUCH, WRONG ANSWER!');
        $('#resultPoints').html('YOUR ANSWER IS INCORRECT AND YOU GOT ' + point + ' POINTS!');
        $('#resultMessage').html('TRY AGAIN AND PLAY ONE MORE TIME');
        $('#result').modal('show');
      } else {
        point = (count) * 20;
        $('#resultTitle').html('CONGRATULATIONS!');
        $('#resultPoints').html('YOUR ANSWER IS CORRECT AND YOU GOT ' + point + ' POINTS!');
        $('#resultMessage').html('YOU CAN RESET AND PLAY AGAIN, TO ACCUMULATE MORE POINTS');
        $('#result').modal('show');
        count = count + 1;
        if (count > 10) {
          count = 1;
        }
      }
    }

    function timer() {
      var secs = 90;
      clearInterval(timer1);
      timer1 = setInterval(function() {

        var min = Math.floor(secs / 60);
        var rem = secs % 60;
        if (rem < 10) {
          rem = '0' + rem;
        }
        if (min < 10) {
          min = '0' + min;
        }
        $("#timer").html(min + ':' + rem);

        if (secs < 1) {
          clearInterval(timer1);
          result();
        }
        secs--;
      }, 1000);
    }

    function shuffleString(string) {
      var parts = string.split('');
      for (var i = parts.length; i > 0;) {
        var random = parseInt(Math.random() * i);
        var temp = parts[--i];
        parts[i] = parts[random];
        parts[random] = temp;
      }
      return parts.join('');
    }

    function getShuffedName(fname, lname) {
      let firstName = '',
        firstNameAddon = '*'.repeat(12 - (fname).length),
        lastName = '',
        lastNameAddon = '*'.repeat(12 - (fname).length);
      firstName = shuffleString(fname + firstNameAddon);
      lastName = shuffleString(lname + lastNameAddon);
      return firstName + ',' + lastName;
    }

    function get_name() {
      var id = ''
      var level = myArray[(count - 1)];
      console.log('get' + level);
      var name = [];
      let fname = nameList[level].fname;
      let lname = nameList[level].lname;
      let data = getShuffedName(fname, lname);
      name = data.split(',');
      //write name
      var i;
      for (i = 1; i <= 12; i++) {
        id = "#firstName" + i;
        if (name[0][i - 1] == '*') {
          $(id).html('&nbsp;');
        } else {
          $(id).html(name[0][i - 1]);
        }

        id = "#lastName" + i;

        if (name[1][i - 1] == '*') {
          $(id).html('&nbsp;');
        } else {
          $(id).html(name[1][i - 1]);
        }
      }
    }

    $(".firstName").draggable({
      revert: true,
      start: drag
    });
    $(".lastName").draggable({
      revert: true,
      start: drag
    });
    $(".firstName").droppable({
      drop: drop,
      accept: ".firstName"
      // over: Hover,
      // out: dragout
    });
    $(".lastName").droppable({
      drop: drop,
      accept: ".lastName"
      // over: Hover,
      // out: dragout
    });

    $("#start").click(function() {
      timer();
      get_name();
      $('#start').html('&nbsp; &nbsp; &nbsp; &nbsp; RESET &nbsp; &nbsp; &nbsp; &nbsp;');
    });

    $("#start-modal").click(function() {
      timer();
      get_name();
      $('#start').html('&nbsp; &nbsp; &nbsp; &nbsp; RESET &nbsp; &nbsp; &nbsp; &nbsp;');
    });

    $("#again").click(function() {
      timer();
      get_name();
      $('#start').html('&nbsp; &nbsp; &nbsp; &nbsp; RESET &nbsp; &nbsp; &nbsp; &nbsp;');
    });

    $('#timer').click(function() {

      clearInterval(timer1);
      $("#timer").html('00:00');
      result();
    });

    $("#end").click(function() {
      count = 1;
      for (i = 1; i <= 12; i++) {
        id = "#firstName" + i;
        $(id).html('&nbsp;');

        id = "#lastName" + i;
        $(id).html('&nbsp;');

      }
      $('#start').html('START THE GAME');
      shuffle(myArray);
    });

    setTimeout(() => {
      $('.routeloader').hide();
    }, 2000)
  },
  methods: {},
  beforeCreate: function() {
    $('body').addClass('wall_street_games');
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('wall_street_games');
    next();
  },
}